import { Link } from "react-router-dom";

export default function SafetySection() {
  const tips = [
    {
      icon: "ri-search-line",
      title: "Zbadaj przed zakupem",
      description: "Zawsze sprawdzaj opinie innych kupujących i historię sprzedawcy przed dokonaniem zakupu. Nasz arkusz zawiera zweryfikowane oceny, które pomogą Ci podjąć właściwą decyzję.",
    },
    {
      icon: "ri-user-star-line",
      title: "Weryfikuj informacje sprzedawcy",
      description: "Upewnij się, że sprzedawca ma dobrą reputację i pozytywne recenzje. W naszym arkuszu oznaczamy zaufanych sprzedawców specjalnym znacznikiem.",
    },
    {
      icon: "ri-lock-line",
      title: "Chroń dane osobowe",
      description: "Nigdy nie udostępniaj wrażliwych danych osobowych poza bezpiecznymi platformami zakupowymi. Korzystaj wyłącznie z oficjalnych kanałów płatności.",
    },
    {
      icon: "ri-ship-line",
      title: "Zrozum ryzyko wysyłki",
      description: "Zapoznaj się z kosztami i czasem dostawy przed złożeniem zamówienia. Nasz arkusz zawiera szacunkowe informacje o dostawie dla każdego produktu.",
    },
  ];

  return (
    <section className="py-16 md:py-20 px-6 md:px-10 lg:px-16 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start">
          <div className="lg:w-[45%]">
            <div className="rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Minimalist%20still%20life%20of%20a%20single%20textured%20ceramic%20vessel%20with%20dried%20botanical%20branch%20on%20smooth%20cream%20pedestal%2C%20soft%20morning%20light%20through%20sheer%20curtain%2C%20editorial%20art%20photography%2C%20warm%20sand%20and%20dusty%20olive%20green%20palette%2C%20tranquil%20serene%20composition%20with%20deep%20shadows&width=800&height=900&seq=safety-shield-v2&orientation=portrait"
                alt="Bezpieczeństwo zakupów"
                className="w-full h-72 md:h-96 object-cover object-top"
              />
            </div>
            <div className="mt-3 bg-foreground-950/90 backdrop-blur-sm rounded-xl px-4 py-3 inline-block">
              <span className="text-background-50 text-xs font-medium">Bestsellery 2026</span>
            </div>
          </div>

          <div className="lg:w-[55%]">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 tracking-tight">
              Bezpieczne korzystanie ze <span className="text-primary-600">Spreadsheet</span>
            </h2>
            <p className="text-foreground-600 mt-3 text-sm leading-relaxed max-w-lg">
              Twoje bezpieczeństwo jest dla nas priorytetem. Poznaj najważniejsze zasady bezpiecznych zakupów i chroń się przed potencjalnymi zagrożeniami.
            </p>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {tips.map((tip) => (
                <div
                  key={tip.title}
                  className="bg-background-100 rounded-xl p-5 border border-background-200/60"
                >
                  <div className="w-10 h-10 rounded-lg bg-secondary-100 flex items-center justify-center mb-3">
                    <i className={`${tip.icon} text-secondary-700 text-lg`}></i>
                  </div>
                  <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-1.5">
                    {tip.title}
                  </h4>
                  <p className="text-foreground-600 text-xs leading-relaxed">
                    {tip.description}
                  </p>
                </div>
              ))}
            </div>

            <div className="mt-6">
              <Link
                to="/artykul/kakobuy-spreadsheet-poradnik"
                className="inline-flex items-center gap-2 text-primary-600 text-sm font-medium hover:text-primary-700 transition-colors"
              >
                <i className="ri-book-open-line"></i>
                Przeczytaj pełny poradnik bezpieczeństwa
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}